module.exports = __webpack_public_path__ + "static/media/addlocationn2.9893b93b.png";